import React from "react";
import { Link } from "react-router-dom";

export default function EventCard({
  slug,
  image,
  titulo,
  data,
  desc,
  estado,
  tipo,
}) {
  return (
    <Link
      to={`/eventos/${encodeURIComponent(slug)}`}
      className="flex flex-col justify-center items-center w-[320px] h-[400px] group "
      tabIndex={0}
      aria-label={`Ver detalle del evento: ${titulo}`}
      style={{ textDecoration: "none" }}
    >
      <div className="relative overflow-hidden rounded-xl w-[300px] h-[200px] shadow-md dark:shadow-gray-700">
        <img
          src={`${image}`}
          className="w-[300px] h-[200px] object-cover"
          alt={titulo || "Evento image"}
        />
      </div>
      <div className="p-4 flex flex-col h-[300px] w-full">
        <div className="h-[80px] overflow-hidden">
          <span className="text-lg font-bold group-hover:text-sidom-orange duration-500">
            {titulo}
          </span>
        </div>
        <div className="h-[60px] overflow-hidden">
          <p className="text-sidom-blue dark:text-sidom-light text-sm mt-3 line-clamp-2">
            {desc}
          </p>
        </div>
        <div className="mt-3">
          <span className="hover:text-sidom-orange font-bold group-hover:text-sidom-orange">
            Leer más <i className="mdi mdi-arrow-right align-middle"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}
